var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertCircle = function SvgAlertCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 2c5.522 0 10 4.478 10 10s-4.478 10-10 10S2 17.523 2 12 6.477 2 12 2m0 1.2a8.802 8.802 0 1 0 .002 17.602A8.802 8.802 0 0 0 12 3.198m.01 11.063a.499.499 0 1 1 0 .998H12a.5.5 0 0 1 0-.998zM12 8.093c.275 0 .499.224.499.5v3.76a.5.5 0 1 1-.998 0v-3.76c0-.276.223-.499.499-.5"
  })));
};
export default SvgAlertCircle;